import styled from 'styled-components';

export const FormFieldStyled = styled.div`
	margin-bottom: 1.7rem;
	position: relative;
`;

export const FormError = styled.span`
	display: block;
	font-size: 1rem;
	color: ${({ theme }) => theme.error.color};
	text-align: left;
	position: absolute;
	right: 0;
	top: 4rem;
`;
